import { VerticalTabNavTitle } from '../../../../../components'
import { UINewsTranslation } from '../../../../../utils'

interface NewsTabNavTitleProps {
  item: UINewsTranslation
}

export const NewsTabNavTitle = ({ item }: NewsTabNavTitleProps) => {
  const { formattedStartDate, header } = item

  return <VerticalTabNavTitle date={formattedStartDate} title={header} />
}
